import firebase from 'firebase/app';
import { AnyShift, Date as DateType } from 'types/shifts';
import { db } from 'utils/firebase';

// The calendar keeps a week in memory for days; writing that copy back would
// undo every change made to the day since (e.g. an event price set elsewhere).
const updateShiftOnDay = <T extends AnyShift = AnyShift>(
  ref: firebase.firestore.DocumentReference,
  shiftId: string,
  patch: (stored: T) => T
) =>
  db.runTransaction(async (transaction) => {
    const current = (await transaction.get(ref)).data() as
      | DateType<T>
      | undefined;

    const stored = current?.shifts?.find((s) => s.id === shiftId);

    if (!stored || current.deletedV02?.some((d) => d.id === shiftId))
      throw new Error('Shift Changed');

    const patched = patch(stored);

    transaction.update(ref, {
      shifts: current.shifts.map((s) => (s.id === shiftId ? patched : s)),
    });

    return patched;
  });

export default updateShiftOnDay;
